import { render, staticRenderFns } from "./EdimensajeFormHeader.vue?vue&type=template&id=1f86d2ea"
import script from "./EdimensajeFormHeader.vue?vue&type=script&lang=js"
export * from "./EdimensajeFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports